import React, { useMemo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Segment, Form, Header, Checkbox, Dropdown } from 'semantic-ui-react';
import styles from '../../../../containers/ReportClaimPage.module.scss';

const AutoInformation = ({ policy, data, onChange, errors, isCPPClaim, cccClaimsDisplay}) => {
    const [noDriver, setNoDriver] = useState(false);

    useEffect(() => {
        setNoDriver(data && (data.involvedDriverNum === -2 || data.noDriverToggle));
    }, [data]);

    const yearOptions = useMemo(() => {
		var years = new Array(new Date().getFullYear() - 1898) 
            .fill()
			.map((_, idx) => {
				return {
                    text: 1900 + idx,
                    value: 1900 + idx
                }
            }
		).reverse();
        return years;
    });

	const driverOptions = useMemo(() => {
		if (!policy.vehicles) return [];
		const drivers = policy.drivers.map((d, i) => {
			return {
				text: d.displayName,
				value: d.driverNum,
				key: i,
			};
		});

		drivers.push({
			text: 'DRIVER NOT LISTED',
			value: -1,
			key: drivers.length,
		});

		drivers.push({
			text: 'NO ONE WAS DRIVING',
			value: -2,
			key: drivers.length,
		});

		return drivers;
	}, [policy]);

	const vehicleOptions = useMemo(() => {
		if (!policy.vehicles) return [];
		const vehicles = policy.vehicles.map((v, i) => {
			return {
				text: v.displayName,
				value: v.vehicleNum,
				key: i,
			};
		});

		vehicles.push({
			text: 'VEHICLE NOT LISTED',
			value: -1,
			key: vehicles.length,
		});

		return vehicles;
	}, [policy]);

	useEffect(() => {
		// handle GAR policies with no vehicles
		if (policy.policyNumber.includes('GAR') && policy.vehicles.length === 0) {
            data.involvedVehicleNum = -1;
		}
        
		//handle GAR policies with no drivers
		if (policy.policyNumber.includes('GAR') && policy.drivers.length === 0 && data.involvedDriverNum !== -2) {
            data.involvedDriverNum = -1;
        }

	}, [policy, data]);

	return (
		<Segment>
            <Header className={styles.header}>Involved Driver and Vehicle Information</Header>
            <div className={styles.row}>
                <div>
                    {policy.drivers &&
                     (
                         <React.Fragment>
                             <a name="involvedDriverNum_FocusAnchor" id="involvedDriverNum_FocusAnchor" href=""/>
                             <Form.Dropdown name='involvedDriverNum' label='Driver' required selection options={driverOptions} value={data.involvedDriverNum} onChange={onChange} error={errors['involvedDriverNum']}/>
                         </React.Fragment>
                     )}

                    {(data.involvedDriverNum === -1 || !policy.drivers) &&
                     (
                         <React.Fragment>
                             <Form.Input name='involvedDriverFirstName' label='Driver First Name' disabled={noDriver} required={!noDriver} value={data.involvedDriverFirstName} onChange={onChange} error={errors['involvedDriverFirstName']}/>
                             <Form.Input name='involvedDriverLastName' label='Driver Last Name' disabled={noDriver} required={!noDriver} value={data.involvedDriverLastName} onChange={onChange} error={errors['involvedDriverLastName']}/>
                            {isCPPClaim && (<Checkbox name='noDriverToggle' label='No one was driving.' value={data.noDriverToggle} onChange={onChange} />)}
                         </React.Fragment>
                     )}
                </div>
                
                <div>
                    {policy.vehicles &&
                     (
                         <React.Fragment>
                             <a name="involvedVehicleNum_FocusAnchor" id="involvedVehicleNum_FocusAnchor" href=""/>
                             <Form.Dropdown name='involvedVehicleNum' label='Vehicle' required selection options={vehicleOptions} value={data.involvedVehicleNum} onChange={onChange} error={errors['involvedVehicleNum']}/>
                         </React.Fragment>
                     )}

                    {(data.involvedVehicleNum === -1 || !policy.vehicles) &&
                     (
                         <React.Fragment>
                             <Form.Input name='involvedVehicleMake' label='Vehicle Make' required value={data.involvedVehicleMake} onChange={onChange} error={errors['involvedVehicleMake']}/>
                             <Form.Input name='involvedVehicleModel' label='Vehicle Model' required value={data.involvedVehicleModel} onChange={onChange} error={errors['involvedVehicleModel']}/>
                             <a name="involvedVehicleYear_FocusAnchor" id="involvedVehicleYear_FocusAnchor" href=""/>
                             <Form.Dropdown name='involvedVehicleYear' options={yearOptions} selection label='Vehicle Year' required value={data.involvedVehicleYear} onChange={onChange} error={errors['involvedVehicleYear']}/>
                         </React.Fragment>
                     )}
                </div>
            </div>
            
            {/*{cccClaimsDisplay && (*/}
            {/*    <div className={styles.row}>*/}
            {/*        <div></div>*/}
            {/*        <Form.Group grouped>*/}
            {/*            <label className={styles.requiredLabel}>Drivable?</label>*/}
            {/*            <Form.Group inline className={styles.claimRadioGroup}>*/}
            {/*                <Form.Radio id="drivableYesRadio" required error={errors['drivable'] ? true : false} label='Yes' className={styles.check} name='drivable' checked={data.drivable === true} onChange={() => onChange(null, { name: 'drivable', value: true })} />*/}
            {/*                <Form.Radio id="drivableNoRadio" required error={errors['drivable'] ? true : false} label='No' className={styles.check} name='drivable' checked={data.drivable === false} onChange={() => onChange(null, { name: 'drivable', value: false })} />*/}
            {/*                <Form.Radio id="drivableUnknownRadio" required error={errors['drivable']} label='Unknown' className={styles.check} name='drivable' checked={data.drivable === -1} onChange={() => onChange(null, { name: 'drivable', value: -1 })} />*/}
            {/*            </Form.Group>*/}
            {/*        </Form.Group>*/}
            {/*    </div>*/}
            {/*)}*/}

            {/*{cccClaimsDisplay && (*/}
            {/*    <div className={styles.row}>*/}
            {/*        <div></div>*/}
            {/*        <Form.Group grouped>*/}
            {/*            <label className={styles.requiredLabel}>Airbag Deployed</label>*/}
            {/*            <Form.Group inline className={styles.claimRadioGroup}>*/}
            {/*                <Form.Radio id="airbagDeployedYesRadio" required error={errors['airbagDeployed'] ? true : false} label='Yes' className={styles.check} name='airbagDeployed' checked={data.airbagDeployed === true} onChange={() => onChange(null, { name: 'airbagDeployed', value: true })} />*/}
            {/*                <Form.Radio id="airbagDeployedNoRadio" required error={errors['airbagDeployed'] ? true : false} label='No' className={styles.check} name='airbagDeployed' checked={data.airbagDeployed === false} onChange={() => onChange(null, { name: 'airbagDeployed', value: false })} />*/}
            {/*                <Form.Radio id="airbagDeployedUnknownRadio" required error={errors['airbagDeployed']} label='Unknown' className={styles.check} name='airbagDeployed' checked={data.airbagDeployed === -1} onChange={() => onChange(null, { name: 'airbagDeployed', value: -1 })} />*/}
            {/*            </Form.Group>*/}
            {/*        </Form.Group>*/}
            {/*    </div>*/}
            {/*)}*/}
            {/*{cccClaimsDisplay && (*/}
            {/*    <div className={styles.row}>*/}
            {/*        <div></div>*/}
            {/*        <Form.Field*/}
            {/*            control={Dropdown}*/}
            {/*            name='airbagDeployed'*/}
            {/*            label='Airbag Deployed'*/}
            {/*            required*/}
            {/*            selection*/}
            {/*            options={[*/}
            {/*                { text: 'Yes', value: 1, key: 1 },*/}
            {/*                { text: 'No', value: 0, key: 0 },*/}
            {/*                { text: 'Unknown', value: -1, key: -1 }]}*/}
            {/*            onChange={onChange}*/}
            {/*            value={data.airbagDeployed}*/}
            {/*            error={errors['airbagDeployed']} />*/}
            {/*    </div>*/}
            {/*)}*/}
            
        </Segment>
	);
};

AutoInformation.propTypes = {
    policy: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    isCPPClaim: PropTypes.bool,
};

export default AutoInformation;
